import React from "react";
import { Helmet } from "react-helmet";
import PageWrapper from "../components/PageWrapper";
import "./css/Trailers.css"; // <-- new (or keep Contact.css but update content)

const Trailers = () => {
  return (
    <>
      <Helmet>
        <title>GTA VI Trailers | Watch Official Rockstar GTA 6 Videos</title>
        <meta
          name="description"
          content="Watch the official Grand Theft Auto VI trailers released by Rockstar Games, including Trailer 1 (Dec 2023) and Trailer 2 (May 2025). Stay updated on the latest GTA 6 gameplay reveals and storyline."
        />
        <link rel="canonical" href="https://www.gtafanpage.com/trailers" />

        {/* Open Graph */}
        <meta property="og:type" content="video.other" />
        <meta
          property="og:title"
          content="GTA VI Official Trailers | Rockstar Games"
        />
        <meta
          property="og:description"
          content="Explore the official GTA 6 trailers released by Rockstar. Dive into the visuals, gameplay, and story of Grand Theft Auto VI."
        />
        <meta property="og:url" content="https://www.gtafanpage.com/trailers" />
        <meta
          property="og:image"
          content="https://img.youtube.com/vi/QdBZY2fkU-0/maxresdefault.jpg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="GTA VI Trailers | Rockstar Official Videos"
        />
        <meta
          name="twitter:description"
          content="Watch all the official trailers for Grand Theft Auto VI. Discover characters, cities, and chaos in Rockstar's most anticipated release."
        />
        <meta
          name="twitter:image"
          content="https://img.youtube.com/vi/VQRLujxTm3c/maxresdefault.jpg"
        />

        {/* Schema: Trailer 1 */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "VideoObject",
            name: "GTA VI Official Trailer 1",
            description:
              "The first official trailer for GTA VI released by Rockstar in December 2023, introducing Vice City, protagonists, and gameplay.",
            thumbnailUrl:
              "https://img.youtube.com/vi/QdBZY2fkU-0/maxresdefault.jpg",
            uploadDate: "2023-12-05T00:00:00Z",
            embedUrl: "https://www.youtube.com/embed/QdBZY2fkU-0",
            publisher: {
              "@type": "Organization",
              name: "Rockstar Games",
              logo: {
                "@type": "ImageObject",
                url: "https://www.gtafanpage.com/logo192.png",
              },
            },
          })}
        </script>
      </Helmet>

      <PageWrapper>
        <div className="trailers-page-wrapper">
          <div className="trailers-card">
            {/* Trailer 2 */}
            <section className="trailer-section">
              <h2 className="trailer-title">Official Trailer 2 – May 2025</h2>
              <div className="video-embed">
                <iframe
                  src="https://www.youtube.com/embed/VQRLujxTm3c"
                  title="GTA VI Official Trailer 2"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
              <p className="trailer-text">
                Rockstar Games released the second official trailer for Grand
                Theft Auto VI in May 2025, building upon the excitement of the
                first reveal. The trailer dives deeper into the game's story,
                highlighting the dynamic relationship between the two
                protagonists, enhanced gameplay mechanics, and the evolved
                open-world environment of Vice City. The visuals showcase
                stunning realism, character depth, and new locations.
              </p>
            </section>

            {/* Trailer 1 */}
            <section className="trailer-section">
              <h2 className="trailer-title">Official Trailer 1 – December 2023</h2>
              <div className="video-embed">
                <iframe
                  src="https://www.youtube.com/embed/QdBZY2fkU-0"
                  title="GTA VI Official Trailer 1"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                />
              </div>
              <p className="trailer-text">
                The first official trailer for GTA VI was released in December
                2023, confirming the long-awaited return to Vice City. It
                introduced fans to the dual protagonist story and the vibrant,
                modern setting full of nightlife, chaos, and criminal intrigue.
                The trailer set the tone for what’s to come with cinematic
                quality, breathtaking visuals, and Rockstar’s signature
                storytelling.
              </p>
            </section>
          </div>
        </div>
      </PageWrapper>
    </>
  );
};

export default Trailers;
